import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './About.css';

const About = () => {
  const { t } = useTranslation();
  return (
    <section className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text" data-aos="fade-right">
            <h2 className="about-title">
              {t('about.title')}
            </h2>
            <p className="about-description">
              {t('about.description')}
            </p>
            <Link to="/sobre" className="about-link">{t('about.action')}</Link>
          </div>
          <div className="about-image" data-aos="fade-left">
            <picture>
              <source type="image/webp" srcSet="/images/ban_02.webp" />
              <img 
                src="/images/ban_02.png" 
                alt="Banner Lumina" 
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


